module.exports = __webpack_public_path__ + "img/uni.b8da8c68.png";